import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Grid} from '@material-ui/core';
import Header from 'Components/common/Header';
import InventroyCard from 'Components/replenishment/InventroyCard';
import {
    getSCInventroyDetails,
    getF1CartCount,
    AddF1Product,
    BatchAddF1Product,
    getMoreStock,
} from 'Actions/replenishment';
import LoadingIcon from 'Components/icons/LoadingIcon';
import {openNotification} from 'Actions/notification';
import ScrollWrapper from 'Components/common/ScrollWrapper';
import SearchInput from 'Components/common/SearchInput';
import BasicButton from 'Components/common/BasicButton';
import Dialog from 'Components/common/Dialog';
import util from 'Utils/commonUtil';
import {T} from 'Actions/translate';

class ReplenishmentSCDetails extends Component {
    editQuantitys = {};
    state = {
        listLoaded: true,
        searchValue: '',
        numProps: null,
        successAll: null,
        load: null,
        addOneSkuToF1CartDialogOpened: false,
        addOneSkuToF1CartMassage: [],
        addBatchSkuToF1CartMassage: [],
        addBatchSkuToF1CartDialogOpened: false,
        currentReplenishmentStockList: {},
        blackSkus: [],
    };

    async componentDidMount() {
        const {localData} = this.props;

        localStorage.setItem('all-black-sku', []);
        let currentScId = localData.defaultScId;
        if (localData) {
            if (localData.roleType === 1)
                this.props.getF1CartCount(currentScId);

            await this.props
                .getSCInventroyDetails(
                    {
                        pageNum: 1,
                        pageSize: 10,
                        supplyCenterId: localData.defaultScId,
                        type: localData.defaultScType,
                    },
                    this.hideLoading,
                )
                .then((res) => {
                    this.setState({
                        currentReplenishmentStockList:
                            this.formatReplenishmentStockList(res),
                    });
                });
        }
        this.setState({
            load: 'load',
        });
    }

    formatReplenishmentStockList = (res, isGetMoreData) => {
        if (res.status === 'success' && res.data.length > 0) {
            res.data.forEach((replenishmentItem) => {
                replenishmentItem.isBlackSku = false;
                this.resetReplenishmentData(replenishmentItem);
            });
        }
        if (
            typeof isGetMoreData !== 'undefined' &&
            isGetMoreData &&
            this.editQuantitys !== '{}'
        ) {
            if (res.status === 'success' && res.data.length > 0) {
                res.data.forEach((replenishmentItem) => {
                    Object.keys(this.editQuantitys).forEach((productItem) => {
                        if (
                            parseInt(productItem) ===
                            parseInt(replenishmentItem.productId)
                        ) {
                            replenishmentItem.tempQuantity = 0;
                        }
                    });
                });

                res.data.forEach((replenishmentItem) => {
                    this.state.blackSkus.length > 0 &&
                        this.state.blackSkus.forEach((blackSkuItem) => {
                            if (blackSkuItem === replenishmentItem.sku) {
                                replenishmentItem.tempQuantity = 0;
                            }
                        });
                });
            }
        }
        return res;
    };

    resetReplenishmentData = (replenishmentItem) => {
        if (
            replenishmentItem.autoStockQuantity &&
            Number(replenishmentItem.autoStockQuantity) > 0
        ) {
            replenishmentItem.tempQuantity =
                replenishmentItem.autoStockQuantity;
        } else {
            replenishmentItem.tempQuantity = 0;
        }
    };

    addFOneShoppingCart = (inventroyDetails, num, event) => {
        this.setState({
            numProps: num,
        });
        const {localData} = this.props;
        const animationTime = 600;

        let isPhoneFlag = false;
        if (
            util.isPhone() &&
            event.touches !== 'undefined' &&
            event.touches &&
            event.touches.length > 0
        ) {
            isPhoneFlag = true;
        }
        const clientX = isPhoneFlag ? event.touches[0].clientX : event.clientX;
        const clientY = isPhoneFlag ? event.touches[0].clientY : event.clientY;
        if (num > 0) {
            this.props
                .AddF1Product({
                    productId: inventroyDetails.productId,
                    quantity: num,
                    sku: inventroyDetails.sku,
                    supplyCenterId: localData.defaultScId,
                })
                .then(() => {
                    const shoppingCartBtn = document.getElementById(
                        'f1-shippingcart-btn',
                    );
                    let params = {
                        shoppingCartBtn: shoppingCartBtn,
                        event: event,
                        animationTime: animationTime,
                        clientX: clientX,
                        clientY: clientY,
                    };
                    util.addShoppingCartAnimation(params);
                    this.editQuantitys = {};
                    this.clearTempQuantity(inventroyDetails);
                })
                .catch((res) => {
                    if (res.status === 'Black_Sku') {
                        this.editQuantitys[inventroyDetails.productId] = 0;

                        let addAllF1 = false;
                        let formatMessageOneData = this.formatBlackList(
                            res.message,
                            addAllF1,
                        );
                        let tempBlackSkus =
                            this.getBlackSkus(formatMessageOneData);
                        formatMessageOneData.length > 0 &&
                            formatMessageOneData.forEach((blackSkuItem) => {
                                if (!tempBlackSkus.includes(blackSkuItem.sku)) {
                                    tempBlackSkus.push(blackSkuItem.sku);
                                }
                            });
                        this.setState({
                            addOneSkuToF1CartDialogOpened: true,
                            addOneSkuToF1CartMassage: formatMessageOneData,
                            currentReplenishmentStockList:
                                this.setIsBlackSku(formatMessageOneData),
                            blackSkus: tempBlackSkus,
                        });
                    }
                });
            return 'success';
        } else {
            this.props.openNotification(
                T('notification_item_quantity_cannot_be_0'),
                'danger',
            );
        }
    };

    getBlackSkus = (formatMessageData) => {
        let tempBlackSkus = [];
        formatMessageData.length > 0 &&
            formatMessageData.forEach((blackSkuItem) => {
                if (!tempBlackSkus.includes(blackSkuItem.sku)) {
                    tempBlackSkus.push(blackSkuItem.sku);
                }
            });
        return tempBlackSkus;
    };

    clearTempQuantity = (inventroyDetails) => {
        let tempReplenishmentStockList = JSON.parse(
            JSON.stringify(this.state.currentReplenishmentStockList),
        );
        if (JSON.stringify(tempReplenishmentStockList) !== '{}') {
            tempReplenishmentStockList.data.length > 0 &&
                tempReplenishmentStockList.data.forEach((tempItem) => {
                    if (tempItem.productId === inventroyDetails.productId) {
                        tempItem.tempQuantity = 0;
                    }
                });
        }
        this.setState({
            currentReplenishmentStockList: tempReplenishmentStockList,
        });
    };

    formatBlackList = (message, addAllF1) => {
        let messageArry = message.length > 0 && message.split('\r\n');
        let newMessageArry = [];
        messageArry.length > 0 &&
            messageArry.forEach((messageItem) => {
                if (messageItem) {
                    let messageObj = {};
                    let itemArry = messageItem.split(',');

                    itemArry.length > 0 &&
                        itemArry.forEach((item, index) => {
                            if (item.length > 0) {
                                let itemArry = item.split(':');
                                if (itemArry[0] === 'productId') {
                                    messageObj.productId = itemArry[1];
                                } else if (itemArry[0] === 'sku') {
                                    messageObj.sku = itemArry[1];
                                } else if (itemArry[0] === 'reason') {
                                    messageObj.reason = itemArry[1];
                                }
                            }
                        });
                    newMessageArry.push(messageObj);
                }
            });

        if (addAllF1) {
            localStorage.setItem(
                'all-black-sku',
                JSON.stringify(newMessageArry),
            );
        }
        return newMessageArry;
    };

    changeNum = (item, quantity) => {
        // console.log(item, quantity);
        this.setState({
            // numProps: quantity,
            successAll: null,
            currentReplenishmentStockList: this.setReplenishmentChangeNum(
                item,
                quantity > 0 ? quantity : 0,
            ),
        });
        if (item.autoStockQuantity !== quantity) {
            this.editQuantitys[item.productId] = parseInt(quantity);
        }
    };

    setReplenishmentChangeNum = (item, quantity) => {
        let tempReplenishmentStockList = JSON.parse(
            JSON.stringify(this.state.currentReplenishmentStockList),
        );
        if (JSON.stringify(tempReplenishmentStockList) !== '{}') {
            tempReplenishmentStockList.data.length > 0 &&
                tempReplenishmentStockList.data.forEach((tempItem) => {
                    if (tempItem.productId === item.productId) {
                        tempItem.tempQuantity = parseInt(quantity);
                    }
                });
        }
        return tempReplenishmentStockList;
    };

    addAll = async (event) => {
        const {localData} = this.props;
        const skuDetails = [];
        const animationTime = 600;
        const clientX = util.isPhone()
            ? event.touches[0].clientX
            : event.clientX;
        const clientY = util.isPhone()
            ? event.touches[0].clientY
            : event.clientY;

        Object.keys(this.editQuantitys).forEach((productId) => {
            skuDetails.push({
                productId,
                quantity: this.editQuantitys[productId],
            });
        });

        let allBlackSkus = [];
        if (
            localStorage.getItem('all-black-sku') &&
            JSON.parse(localStorage.getItem('all-black-sku')).length > 0
        ) {
            allBlackSkus = JSON.parse(localStorage.getItem('all-black-sku'));
        }
        allBlackSkus.length > 0 &&
            allBlackSkus.forEach((blackItem) => {
                let isAddSku = true;
                skuDetails.length > 0 &&
                    skuDetails.forEach((skuItem) => {
                        if (blackItem.productId === skuItem.productId) {
                            isAddSku = false;
                            if (skuItem.quantity) {
                                skuItem.quantity = skuItem.quantity;
                            } else {
                                skuItem.quantity = 0;
                            }
                        }
                    });
                if (isAddSku) {
                    skuDetails.push({
                        productId: blackItem.productId,
                        quantity: 0,
                    });
                }
            });

        this.props
            .BatchAddF1Product({
                supplyCenterId: localData.defaultScId,
                skuDetails,
            })
            .then(() => {
                const shoppingCartBtn = document.getElementById(
                    'f1-shippingcart-btn',
                );
                let params = {
                    shoppingCartBtn: shoppingCartBtn,
                    event: event,
                    animationTime: animationTime,
                    clientX: clientX,
                    clientY: clientY,
                };

                util.addShoppingCartAnimation(params);
                this.editQuantitys = {};
                localStorage.setItem('all-black-sku', []);
                this.setState({
                    numProps: 0,
                    successAll: 'success',
                    currentReplenishmentStockList: this.resetTempQuantity(),
                });
            })
            .catch((res) => {
                if (res.status === 'Black_Sku') {
                    let addAllF1 = true;
                    let formatMessageData = this.formatBlackList(
                        res.message,
                        addAllF1,
                    );
                    let tempBlackSkus = this.getBlackSkus(formatMessageData);

                    this.setState({
                        addBatchSkuToF1CartDialogOpened: true,
                        addBatchSkuToF1CartMassage: formatMessageData,
                        currentReplenishmentStockList:
                            this.setIsBlackSku(formatMessageData),
                        blackSkus: tempBlackSkus,
                    });
                }
            });
    };

    resetTempQuantity = () => {
        let tempReplenishmentStockList = JSON.parse(
            JSON.stringify(this.state.currentReplenishmentStockList),
        );
        if (JSON.stringify(tempReplenishmentStockList) !== '{}') {
            tempReplenishmentStockList.data.length > 0 &&
                tempReplenishmentStockList.data.forEach((tempItem) => {
                    if (tempItem.tempQuantity > 0) {
                        tempItem.tempQuantity = 0;
                    }
                });
        }
        return tempReplenishmentStockList;
    };

    setIsBlackSku = (formatMessageData) => {
        let replenishmentDataList = JSON.parse(
            JSON.stringify(this.state.currentReplenishmentStockList),
        );
        replenishmentDataList.data.length > 0 &&
            replenishmentDataList.data.forEach((replenishmentData) => {
                formatMessageData.length > 0 &&
                    formatMessageData.forEach((messageItem) => {
                        if (replenishmentData.sku === messageItem.sku) {
                            replenishmentData.isBlackSku = true;
                            replenishmentData.tempQuantity = 0;
                        }
                    });
            });
        return replenishmentDataList;
    };

    getCurrentSkuList = () => {
        let tempReplenishmentStockList = JSON.parse(
            JSON.stringify(this.state.currentReplenishmentStockList),
        );
        let replenishmentSkuLists = [];
        if (
            tempReplenishmentStockList.status === 'success' &&
            tempReplenishmentStockList.data.length > 0
        ) {
            tempReplenishmentStockList.data.forEach((replenishmentItem) => {
                Object.keys(this.editQuantitys).forEach((productItem) => {
                    if (replenishmentItem.productId === parseInt(productItem)) {
                        let replenishmentObj = {
                            sku: replenishmentItem.sku,
                            productId: replenishmentItem.productId,
                        };
                        replenishmentSkuLists.push(replenishmentObj);
                    }
                });
            });
        }
        return replenishmentSkuLists;
    };

    goToF1Cart = () => {
        this.props.history.push('/replenishmentCart');
    };

    hideLoading = () => {
        this.setState({
            listLoaded: false,
        });
    };

    getMore = () => {
        const {localData, replenishmentStockList} = this.props;
        let tempReplenishmentStockList = JSON.parse(
            JSON.stringify(this.state.currentReplenishmentStockList),
        );
        const {searchValue} = this.state;

        this.props
            .getMoreStock({
                pageSize: 10,
                pageNum:
                    tempReplenishmentStockList &&
                    tempReplenishmentStockList.pageNum
                        ? tempReplenishmentStockList.pageNum + 1
                        : 1,
                supplyCenterId: localData.defaultScId,
                type: localData.defaultScType,
                queryKey: searchValue,
            })
            .then((res) => {
                let isGetMoreData = true;
                this.setState({
                    currentReplenishmentStockList:
                        this.formatReplenishmentStockList(res, isGetMoreData),
                });
            });
    };
    goBack = () => this.props.history.push('/replenishmentMgmt');

    handleSearch = (title, value) => {
        const {localData} = this.props;

        this.props
            .getSCInventroyDetails(
                {
                    pageNum: 1,
                    pageSize: 10,
                    supplyCenterId: localData.defaultScId,
                    type: localData.defaultScType,
                    queryKey: value,
                },
                this.hideLoading,
            )
            .then((res) => {
                this.setState({
                    currentReplenishmentStockList:
                        this.formatReplenishmentStockList(res),
                });
            });

        this.setState({[title]: value});
    };

    linkApplyList = () => {
        const params = {
            type: 'stock',
            scName: this.props.localData.scName,
            scId: this.props.localData.scId,
        };
        this.props.history.push(`/applyForListing`, params);
    };

    dialogDidClose = (dialog) =>
        this.state[dialog] &&
        this.setState({
            [dialog]: false,
            addOneSkuToF1CartMassage: [],
            addBatchSkuToF1CartMassage: [],
        });

    render() {
        const {
            replenishmentStockList,
            localData,
            f1CartCount,
            stockLoadingMore,
            stockListLoaded,
        } = this.props;
        const {
            listLoaded,
            searchValue,
            numProps,
            successAll,
            load,
            addOneSkuToF1CartMassage,
            addOneSkuToF1CartDialogOpened,
            addBatchSkuToF1CartMassage,
            addBatchSkuToF1CartDialogOpened,
            currentReplenishmentStockList,
        } = this.state;

        return (
            <div className="replenishment-sc-details">
                <div className="container-max-width is-fixed background"></div>
                <div className="container-max-width is-fixed background-cover"></div>

                <Header
                    hasF1ShoppingCart={localData.roleType === 3 ? false : true}
                    hasUserCenter={true}
                    increment={0}
                    f1CartCount={f1CartCount}
                    F1ShoppingCartEvent={this.goToF1Cart}
                    hasArrowBackIos={true}
                    backEvent={this.goBack}>
                    <Grid
                        className="page-title-container no-margin"
                        container
                        spacing={0}
                        justify={'space-evenly'}>
                        <Grid className="page-title" item xs={12}>
                            <span>{T('fone_order_inventory_details')}</span>
                        </Grid>
                    </Grid>

                    <Grid
                        className="supply-center-container no-margin"
                        container
                        spacing={0}
                        justify={'space-evenly'}>
                        <Grid
                            className="supply-center-title text-ellipsis"
                            item
                            xs={12}>
                            <span>
                                {T('fone_order_current_is')}{' '}
                                {localData.defaultScName}
                            </span>
                        </Grid>
                    </Grid>

                    <Grid
                        className="page-search-container no-margin"
                        container
                        spacing={0}
                        justify={'space-evenly'}>
                        <Grid item xs={11}>
                            <SearchInput
                                title="searchValue"
                                value={searchValue}
                                onChange={this.handleSearch}
                                options={{hideSearchBtn: true}}
                                placeholder={T('enter_sku')}></SearchInput>
                        </Grid>
                    </Grid>
                </Header>

                {listLoaded ? (
                    <LoadingIcon className="circle-animation" />
                ) : (
                    <ScrollWrapper
                        showLoadingMore={stockLoadingMore}
                        showAbyss={
                            currentReplenishmentStockList.pageNum >=
                            currentReplenishmentStockList.pageTotal
                        }
                        getMoreData={this.getMore}
                        listLoaded={stockListLoaded}>
                        <Grid
                            className="replenishment-sc-list-container no-margin"
                            container
                            spacing={0}
                            justify={'space-evenly'}>
                            {currentReplenishmentStockList.data &&
                                currentReplenishmentStockList.data.map(
                                    (item, i) => (
                                        <Grid
                                            className="replenishment-sc-list"
                                            key={item.productId}
                                            item
                                            xs={11}>
                                            {load !== null ? (
                                                <InventroyCard
                                                    inventroyDetails={item}
                                                    addFOneShoppingCart={
                                                        this.addFOneShoppingCart
                                                    }
                                                    changeNum={this.changeNum}
                                                    localData={localData}
                                                    addAll={this.addAll}
                                                    numProps={item.tempQuantity}
                                                    successAll={successAll}
                                                />
                                            ) : null}
                                        </Grid>
                                    ),
                                )}
                        </Grid>
                        {localData.roleType === 3 ? (
                            <div
                                className={`apply_for_listing_product_btn  ${
                                    currentReplenishmentStockList.data &&
                                    currentReplenishmentStockList.data
                                        .length === 0
                                        ? 'apply_for_listing_product_btn_top'
                                        : null
                                }`}>
                                <BasicButton
                                    type="primary"
                                    className="new-transfer-btn"
                                    onClickOfSingleTap={this.linkApplyList}
                                    isStopPropagation={true}>
                                    {T('apply_for_listing_product')}
                                </BasicButton>
                            </div>
                        ) : null}
                    </ScrollWrapper>
                )}

                <Dialog
                    opened={addOneSkuToF1CartDialogOpened}
                    dialogDidClose={() =>
                        this.dialogDidClose('addOneSkuToF1CartDialogOpened')
                    }
                    options={{bgClickClose: true}}>
                    <div className="confirm-cancel-F1-order-dialog">
                        <h5>{T('fone_order_query_by_sku')}</h5>
                        <p>
                            {typeof addOneSkuToF1CartMassage !== 'undefined' &&
                                addOneSkuToF1CartMassage.length > 0 &&
                                addOneSkuToF1CartMassage.map((message) => (
                                    <div>
                                        {message.sku}{' '}
                                        {T('black_list_sku_reason')}:{' '}
                                        {message.reason}
                                    </div>
                                ))}
                        </p>
                        <BasicButton
                            className="confirm-btn"
                            type="primary"
                            onClickOfSingleTap={() =>
                                this.dialogDidClose(
                                    'addOneSkuToF1CartDialogOpened',
                                )
                            }>
                            {T('getInfo')}
                        </BasicButton>
                    </div>
                </Dialog>

                <Dialog
                    opened={addBatchSkuToF1CartDialogOpened}
                    dialogDidClose={() =>
                        this.dialogDidClose('addBatchSkuToF1CartDialogOpened')
                    }
                    options={{bgClickClose: true}}>
                    <div className="confirm-cancel-F1-order-dialog">
                        <h5>{T('fone_order_query_by_sku')}</h5>
                        <p>
                            {typeof addBatchSkuToF1CartMassage !==
                                'undefined' &&
                                addBatchSkuToF1CartMassage.length > 0 &&
                                addBatchSkuToF1CartMassage.map(
                                    (message, messageIndex) => (
                                        <div
                                            key={messageIndex}
                                            className="batch-black-sku">
                                            {message.sku}{' '}
                                            {T('black_list_sku_reason')}:{' '}
                                            {message.reason}
                                        </div>
                                    ),
                                )}
                        </p>
                        <BasicButton
                            className="confirm-btn"
                            type="primary"
                            onClickOfSingleTap={() =>
                                this.dialogDidClose(
                                    'addBatchSkuToF1CartDialogOpened',
                                )
                            }>
                            {T('getInfo')}
                        </BasicButton>
                    </div>
                </Dialog>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {replenishment, localData} = state;
    return {
        localData: localData,
        replenishmentStockList: replenishment.replenishmentStockList,
        f1CartCount: replenishment.f1CartCount,
        stockLoadingMore: replenishment.stockLoadingMore,
        stockListLoaded: replenishment.stockListLoaded,
    };
};

const mapDispatchToProps = {
    getSCInventroyDetails,
    getF1CartCount,
    AddF1Product,
    BatchAddF1Product,
    openNotification,
    getMoreStock,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ReplenishmentSCDetails);
